module.exports = __webpack_public_path__ + "media/application/images/2018/my-consumer-bin-red@2x-6d803b7fe3cba11015ea69a0d97fe805.png";